import { __assign, __rest } from "tslib";
import React from 'react';
import { addIconPropsToObject } from '../utilities';
export var SvgIconButtonShim = function (_a) {
    var svgIconsEnabled = _a.svgIconsEnabled, Button = _a.buttonAs, rest = __rest(_a, ["svgIconsEnabled", "buttonAs"]);
    if (svgIconsEnabled) {
        var menuIconProps = rest.menuIconProps, iconProps = rest.iconProps;
        mutateIconProps({ menuIconProps: menuIconProps, iconProps: iconProps });
    }
    return React.createElement(Button, __assign({}, rest));
};
var mutateIconProps = function (_a) {
    var menuIconProps = _a.menuIconProps, iconProps = _a.iconProps;
    addIconPropsToObject(menuIconProps);
    addIconPropsToObject(iconProps);
};
//# sourceMappingURL=SvgIconButtonShim.js.map